// extracted by mini-css-extract-plugin
export default {"postEditPage":"_1Oyjw"};